import dayjs from '../../dayjs';

/**
 * @description: 根据年份获半年的date信息
 * @param {number} year
 * @return {*}
 */
export function getHalYearByYear(year: number) {
  const halfYearAry: any[] = []
  for (let i = 0; i < 2; i++) {
    const start = dayjs().year(year).set('month', i * 6).set('date', 1)
    const end = dayjs().year(year).set('month', (i + 1) * 6).set('date', 0)
    halfYearAry.push({
      start: new Date(+start),
      end: new Date(+end),
      halfYearNumber: i + 1,
      halfYear: `${year}-H${i + 1}`
    })
  }
  return halfYearAry
}